import React from 'react';

import ImageSequence from './ImageSequence.js';


export default ({size, n, mobileN, source, alt}) => <ImageSequence
    n={n} mobileN={mobileN}
    imageGetter={i => [require(`../images/${source}/${i}.png`), size, alt(i)]}
/>;
